module.exports = __webpack_public_path__ + "img/1.61aab9b2.png";